<template>
  <BootstrapDialog
    title="选择注册范围"
    ref="dialog"
    size="lg"
    @afterClose="afterClose()"
  >
    <template v-slot:body>
      <div style="padding: 20px">
        <table
          style="width:800px;margin:0 auto;backgroundColor:#F5F5F5;border: 1px soild #696969"
        >
          <thead>
            <tr>
              <th>套餐限制类型</th>
              <th>限制类型</th>
              <th>
                <button
                  type="button"
                  class="btn "
                  style="backgroundColor:#2E8B57;color:#FFFAFA"
                  @click="add()"
                >
                  <span
                    class="glyphicon glyphicon-plus"
                    aria-hidden="true"
                  ></span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in regRanges" :key="index + 'b'">
              <td>
                <BootstrapCombobox
                  :data="xzlxArr"
                  value-field="value"
                  text-field="text"
                  v-model="item.xzlx"
                  :formatOption="(xzlx) => xzlx.text"
                  @change="xzlxChange(item)"
                ></BootstrapCombobox>
              </td>
              <td>
                <BootstrapCombobox
                  :data="item.xzzArr"
                  value-field="id"
                  text-field="mc"
                  v-model="item.xzz"
                  :formatOption="(xzz) => xzz.mc"
                ></BootstrapCombobox>
              </td>
              <td>
                <button
                  type="button"
                  class="btn "
                  style="backgroundColor:#FF4500;color:#FFFAFA"
                  @click="del(index)"
                >
                  <span
                    class="glyphicon glyphicon-trash"
                    aria-hidden="true"
                  ></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-slot:footer>
      <button class="btn btn-primary" type="button" @click="save()">
        确认
      </button>
      <button
        style="margin-left:10px"
        class="btn btn-default"
        type="button"
        @click="close()"
      >
        关闭
      </button>
    </template>
  </BootstrapDialog>
</template>
<script>
import { xzlx } from "@/plugins/enums.js";
export default {
  props: {
    regrangesArr: {
      type: Array,
    },
  },
  name: "PackageMgUerchoose",
  components: {},
  data: function() {
    return {
      // 套餐限制类型
      xzlxArr: [],
      regRanges: [
        {
          xzlx: null,
          xzz: null,
        },
      ],
      arrData: [1],
      jsList: [],
      model: {
        name: "",
        ztlb: "",
      },
    };
  },
  created() {
    this.xzlxArr = xzlx;
    this.regRanges = this.regrangesArr;
  },
  watch: {
    regranges: {
      deep: true,
      handler(val) {
        this.regRanges = val;
        val.forEach((item, i) => {
          this.regRanges[i].xzlx = item.xzlx;
          this.regRanges[i].xzz = item.xzz;
        });
      },
    },
  },

  methods: {
    xzlxChange(item) {
      let poUrl = "/htgl/biz/cw/tc/limit";
      this.$http.post(poUrl, { xzlx: item.xzlx }).then((res) => {
        item.xzzArr = res.data;
      });
    },

    // 删除
    del(index) {
      this.regRanges.splice(index, 1);
    },
    //  点击添加
    add() {
      let obj = {
        xzlx: null,
        xzz: null,
        xzzArr: [],
      };
      this.regRanges.push(obj);
    },
    reset: function() {
      this.model = {};
    },
    async open() {
      this.regRanges = [
        {
          xzlx: null,
          xzz: null,
          xzzArr: [],
        },
      ];
      this.$refs.dialog.open();
    },
    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },
    showOption: function(item) {
      return item.code + "-" + item.text;
    },
    save() {
      this.regRanges.forEach((item) => {
        if (item.xzlx == null || item.xzz == null) {
          this.$error("请把注册信息补充完整");
        } else {
          this.$emit("sendXzfwData", this.regRanges);
          this.close();
        }
      });
    },
  },
};
</script>
<style scoped>
th,
td {
  padding: 10px;
}
</style>
